{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            Copyright (c) 2025                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.DataGrid.DataAdapter.Base;

{$IFNDEF PAS2JS}
  {$DEFINE DESIGNER}
{$ELSE}
  {$MODE DELPHI}
{$ENDIF}




interface
uses
  WEBLib.DataGrid.Common,
  Classes, libdatagrid, WEBLib.Controls,
  WEBLib.DataGrid.libjs,
  WEBLib.DataGrid.Options,
  Data.DB, Types,
  JS, jsdelphisystem, Web, SysUtils;

type
  TJSFetchErrorResponse = class;
  TDGServerDSCompletionCallback = reference to procedure();
  TDGServerDSErrorCompletionCallback = reference to procedure();
  TDGServerDSCallback = reference to procedure(Response: TJSObject);
  TDGServerDSErrorCallback = reference to procedure(Response: TJSFetchErrorResponse);

  TDGServerDSRefreshed = reference to procedure();
  TDGServerDataAdapter = class;
  TDGServerDSPaginationChanged = procedure(Sender: TComponent; CurrentPage: Integer; PaginationSize: Integer) of object;
  PSGServerDSPaginationChanged = {$IFNDEF PAS2JS}^{$ENDIF}TDGServerDSPaginationChanged;

  TDGServerDSDataChanged = procedure(Sender: TComponent) of object;
  PSGServerDSDataChanged = {$IFNDEF PAS2JS}^{$ENDIF}TDGServerDSDataChanged;


  TJSFetchErrorResponse = class
  public
    Response: TJSFetchResponse;
    Error: TJSError;
    Type_: String;
    StatusCode: Integer;
    StatusText: String;
    ResponseText: String;
  end;

  TDGGetRowsQueueItem = class
  public
    Params: TJSGetRowsParams;
    SavedAfterOpen: TDataSetNotifyEvent;

  end;

{$REGION 'Base Classes'}
  TDGServerDataAdapter = class abstract (TComponent)
  protected
    FRefreshedCallback: TDGServerDSRefreshed;
    FDebug: Boolean;
    FDataCache: TJSArray;
    FPaginationSize: Integer;
    FCurrentPage: Integer;
    FPaginationChangeCallbacks: TList;
    FSortModel: TJSValue;
    FFilterModel: TJSValue;
{$REGION 'Data Change Callbacks'}
    FDataChangeCallbacks: TList;
    function CallDataChangeHandlers: Boolean;
{$ENDREGION}

  protected
    procedure SetPaginationSize(const Value: Integer); virtual;
    procedure SetCurrentPage(const Value: Integer); virtual;

    function CallPaginationChangeHandlers: Boolean; virtual;

    procedure SetSortModel(const Value: TJSValue); virtual;

    procedure SetFilterModel(const Value: TJSValue); virtual;

    procedure TriggerRefreshCallback;

    property SortModel: TJSValue read FSortModel write SetSortModel;
    property FilterModel: TJSValue read FFilterModel write SetFilterModel;



    procedure UpdateRow(DataGrid: TComponent; RowData: TJSObject; Callback: TDGServerDSCallback = nil; ErrorCallBack: TDGServerDSErrorCallback = nil); overload; virtual; {$IFDEF PAS2JS}async;{$ENDIF}
  public
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    property PaginationSize: Integer read FPaginationSize write SetPaginationSize;
    property CurrentPage: Integer read FCurrentPage write SetCurrentPage;
    function RegisterPaginationChangeHandler(Callback: TDGServerDSPaginationChanged): Boolean; virtual;
    function UnregisterPaginationChangeHandler(Callback: TDGServerDSPaginationChanged): Boolean; virtual;
{$REGION 'Data Change Callbacks'}
    function RegisterDataChangeHandler(
      Callback: TDGServerDSDataChanged): Boolean;
    function UnregisterDataChangeHandler(
      Callback: TDGServerDSDataChanged): Boolean;
{$ENDREGION}
    property Debug: Boolean read FDebug write FDebug;
    procedure HandleGetRows(Params: TJSGetRowsParams); virtual; abstract;
    procedure UpdateRow(RowData: TJSObject; Callback: TDGServerDSCallback = nil; ErrorCallBack: TDGServerDSErrorCallback = nil); overload; virtual; abstract; {$IFDEF PAS2JS}async;{$ENDIF}
    procedure DeleteRow(RowData: TJSObject; Callback: TDGServerDSCallback = nil; ErrorCallBack: TDGServerDSErrorCallback = nil); virtual; abstract; {$IFDEF PAS2JS}async;{$ENDIF}
    procedure InsertRow(RowData: TJSObject; Callback: TDGServerDSCallback = nil; ErrorCallBack: TDGServerDSErrorCallback = nil); virtual; abstract; {$IFDEF PAS2JS}async;{$ENDIF}
    procedure LoadSchema(ColumnDefs: TDGColumnDefsCollection; Callback: TDGServerDSCompletionCallback; ErrorCallBack: TDGServerDSErrorCompletionCallback = nil); virtual; {$IFDEF PAS2JS}async;{$ENDIF}

    function Fetch(RequestUrl: String; RequestConfig: TJSObject; SuccessCallback: TDGServerDSCallback; ErrorCallBack: TDGServerDSErrorCallback): Boolean; overload; {$IFDEF PAS2JS}async;{$ENDIF}

  protected
    function GetServerRowCount(): Integer; virtual;
    function GetCacheCount(): Integer; virtual;
    function GetOffset(): Integer; virtual;
    procedure WhenGridRefreshed(Callback: TDGServerDSRefreshed = nil); virtual;
    property DataCache: TJSArray read FDataCache write FDataCache;
    procedure UpdatePaginationParameters(Sender: TComponent; CurrentPage: Integer; PaginationSize: Integer); virtual;
  end;

  TDGServerDataAdapterWithPaging = class abstract (TDGServerDataAdapter)
  public
    procedure LoadDataSet(CurrentPage: Integer; PaginationSize: Integer); virtual; abstract;
  end;
{$ENDREGION}


implementation

{$REGION 'Base Classes'}
{$REGION 'TDGServerDataAdapter'}

{ TDGServerDataAdapter }

constructor TDGServerDataAdapter.Create(AOwner: TComponent);
begin
  inherited;
  FCurrentPage := -1;
  FPaginationSize := -1;
  FPaginationChangeCallbacks := TList.Create;
end;

destructor TDGServerDataAdapter.Destroy;
begin
  if Assigned(FPaginationChangeCallbacks) then
    FreeAndNil(FPaginationChangeCallbacks);
  inherited;
end;


function TDGServerDataAdapter.Fetch(RequestUrl: String;
  RequestConfig: TJSObject; SuccessCallback: TDGServerDSCallback;
  ErrorCallBack: TDGServerDSErrorCallback): Boolean;
var
  Response: TJSFetchResponse;
  JsonObject: TJSObject;
  ErrorResponse: TJSFetchErrorResponse;
begin
  Result := False;
  try
    Response := TJSFetchResponse(Pointer(_await(TJSFetch.fetch(RequestUrl, RequestConfig))));
    if Response.ok then
    begin
      if Assigned(SuccessCallback) then
      begin
        try
          JsonObject := TJSObject(Pointer(await(Response.json)));
        except on Err: TJSSyntaxError do
          JsonObject := nil;
        end;
        SuccessCallback(JsonObject);
        Result := True;
      end;
    end
    else
    begin
      if Assigned(ErrorCallBack) then
      begin
        try
          ErrorResponse := TJSFetchErrorResponse.Create;
          ErrorResponse.Response := Response;
          ErrorResponse.Error := nil;
          ErrorResponse.Type_ := Response.Type_;
          ErrorResponse.StatusCode := Response.Status;
          ErrorResponse.StatusText := Response.StatusText;
          ErrorResponse.ResponseText := await(Response.Text);
          ErrorCallBack(ErrorResponse);
        finally
          FreeAndNil(ErrorResponse);
        end;
      end;
    end;
  except on E: TJSError do
    begin
      if Assigned(ErrorCallBack) then
      begin
        try
          ErrorResponse := TJSFetchErrorResponse.Create;
          ErrorResponse.Error := E;
          ErrorResponse.Type_ := 'Error';
          ErrorResponse.StatusText := E.Message;
          ErrorCallBack(ErrorResponse);
        finally
          FreeAndNil(ErrorResponse);
        end;
      end
      else
        raise E;
    end;
  end;
end;


function TDGServerDataAdapter.GetCacheCount: Integer;
begin
  Result := -1;
end;


function TDGServerDataAdapter.GetOffset: Integer;
begin
  Result := -1;
end;

function TDGServerDataAdapter.GetServerRowCount: Integer;
begin
  Result := -1;
end;

procedure TDGServerDataAdapter.LoadSchema(ColumnDefs: TDGColumnDefsCollection;
  Callback: TDGServerDSCompletionCallback;
  ErrorCallBack: TDGServerDSErrorCompletionCallback);
begin
  if Assigned(Callback) then
    Callback;
end;


function TDGServerDataAdapter.CallPaginationChangeHandlers: Boolean;
var
  I, Len: Integer;
  Callback: TDGServerDSPaginationChanged;
begin
  Result := False;
  Len := FPaginationChangeCallbacks.Count;
  for I := 0 to Len - 1 do
  begin
    Callback := PSGServerDSPaginationChanged(FPaginationChangeCallbacks[I]){$IFNDEF PAS2JS}^{$ENDIF};
    Callback(Self, FCurrentPage, FPaginationSize);
    Result := True;
  end;
end;


function TDGServerDataAdapter.RegisterPaginationChangeHandler(
  Callback: TDGServerDSPaginationChanged): Boolean;
var
  I, Len: Integer;
  Found: Boolean;
begin
  Result := False;
  Found := False;
  if Assigned(Callback) then
  begin
    if (_typeof(FPaginationChangeCallbacks) = 'undefined') or
       (FPaginationChangeCallbacks = nil) then
    begin
      FPaginationChangeCallbacks := TList.Create;
    end;
    Len := FPaginationChangeCallbacks.Count;
    for I := 0 to Len - 1 do
    begin
      if {$IFNDEF PAS2JS}@{$ENDIF}Callback = FPaginationChangeCallbacks.Items[I] then
      begin
        Found := True;
        Break;
      end;
    end;

    if not Found then
      FPaginationChangeCallbacks.Add({$IFNDEF PAS2JS}@{$ENDIF}Callback);
  end;
end;

function TDGServerDataAdapter.UnregisterPaginationChangeHandler(
  Callback: TDGServerDSPaginationChanged): Boolean;
var
  I, Len: Integer;
begin
  Result := False;
  if Assigned(FPaginationChangeCallbacks) then
  begin
    Len := FPaginationChangeCallbacks.Count;
    for I := Len - 1 downto 0 do
    begin
      if {$IFNDEF PAS2JS}@{$ENDIF}Callback = FPaginationChangeCallbacks.Items[I] then
      begin
        FPaginationChangeCallbacks.Delete(I);
        Result := True;
        Break;
      end;
    end;
  end;
end;

procedure TDGServerDataAdapter.UpdatePaginationParameters(Sender: TComponent;
  CurrentPage, PaginationSize: Integer);
var
  Changed: Boolean;
begin
  Changed := False;
  if FCurrentPage <> CurrentPage then
  begin
    FCurrentPage := CurrentPage;
    Changed := True;
  end;
  if FPaginationSize <> PaginationSize then
  begin
    FPaginationSize := PaginationSize;
    Changed := True;
  end;
  if Changed then
    CallPaginationChangeHandlers;

end;

procedure TDGServerDataAdapter.UpdateRow(DataGrid: TComponent;
  RowData: TJSObject; Callback: TDGServerDSCallback;
  ErrorCallBack: TDGServerDSErrorCallback);
begin
  UpdateRow(RowData, Callback, ErrorCallBack);
end;

procedure TDGServerDataAdapter.SetCurrentPage(const Value: Integer);
begin
  if FCurrentPage <> Value then
  begin
    FCurrentPage := Value;
    CallPaginationChangeHandlers;
  end;
end;

procedure TDGServerDataAdapter.SetFilterModel(const Value: TJSValue);
begin
  if FFilterModel <> Value then
  begin
    FFilterModel := Value;
    CallPaginationChangeHandlers;
  end;
end;

procedure TDGServerDataAdapter.SetPaginationSize(const Value: Integer);
begin
  if FPaginationSize <> Value then
  begin
    FPaginationSize := Value;
    CallPaginationChangeHandlers;
  end;
end;

procedure TDGServerDataAdapter.SetSortModel(const Value: TJSValue);
begin
  if FSortModel <> Value then
  begin
    FSortModel := Value;
    CallPaginationChangeHandlers;
  end;
end;

procedure TDGServerDataAdapter.TriggerRefreshCallback;
begin
  if Assigned(FRefreshedCallback) then
  begin
    FRefreshedCallback;
    FRefreshedCallback := nil;
  end;
end;

procedure TDGServerDataAdapter.WhenGridRefreshed(Callback: TDGServerDSRefreshed);
begin
  FRefreshedCallback := Callback;
end;

{$REGION 'Data Change Callbacks'}

function TDGServerDataAdapter.CallDataChangeHandlers: Boolean;
var
  I, Len: Integer;
  Callback: TDGServerDSDataChanged;
begin
  Result := False;
  Len := FDataChangeCallbacks.Count;
  for I := 0 to Len - 1 do
  begin
    Callback := PSGServerDSDataChanged(FDataChangeCallbacks[I]){$IFNDEF PAS2JS}^{$ENDIF};
    Callback(Self);
    Result := True;
  end;
end;

function TDGServerDataAdapter.RegisterDataChangeHandler(
  Callback: TDGServerDSDataChanged): Boolean;
var
  I, Len: Integer;
  Found: Boolean;
begin
  Result := False;
  Found := False;
  if Assigned(Callback) then
  begin
    if (_typeof(FDataChangeCallbacks) = 'undefined') or
       (FDataChangeCallbacks = nil) then
    begin
      FDataChangeCallbacks := TList.Create;
    end;
    Len := FDataChangeCallbacks.Count;
    for I := 0 to Len - 1 do
    begin
      if {$IFNDEF PAS2JS}@{$ENDIF}Callback = FDataChangeCallbacks.Items[I] then
      begin
        Found := True;
        Break;
      end;
    end;

    if not Found then
      FDataChangeCallbacks.Add({$IFNDEF PAS2JS}@{$ENDIF}Callback);
  end;
end;

function TDGServerDataAdapter.UnregisterDataChangeHandler(
  Callback: TDGServerDSDataChanged): Boolean;
var
  I, Len: Integer;
begin
  Result := False;
  if Assigned(FDataChangeCallbacks) then
  begin
    Len := FDataChangeCallbacks.Count;
    for I := Len - 1 downto 0 do
    begin
      if {$IFNDEF PAS2JS}@{$ENDIF}Callback = FDataChangeCallbacks.Items[I] then
      begin
        FDataChangeCallbacks.Delete(I);
        Result := True;
        Break;
      end;
    end;
  end;
end;


{$ENDREGION}


{$ENDREGION}

{$ENDREGION}

end.
